import { GTMEvent } from '../GTM'
import { formatPrice } from '@corratech/pylot-seo'
import { itemHasKeys } from '@corratech/pylot-utils'

export type GTMProductData = {
    name: string
    id: string
    price: number
    currencyCode?: string
    category?: string
    categoryPath?: string
    brand?: string
    product_type?: string
    is_sale_item?: string
    type?: string
}

export const isValidProductItemData = (
    data: unknown
): data is GTMProductData => {
    return itemHasKeys(data, ['name', 'id', 'price'])
}

export const pushPdp = (data: Record<string, unknown>): GTMEvent => {
    if (!isValidProductItemData(data)) {
        console.info('Invalid GTM PDP data')
        return { event: '' }
    }

    const {
        category,
        name,
        id,
        price,
        currencyCode,
        categoryPath,
        brand,
        is_sale_item,
        type
    } = data
    return {
        event: type ? String(type) : 'product',
        ecommerce: {
            detail: {
                actionField: {
                    list: category ? `Category - ${category}` : ''
                },
                products: [
                    {
                        name,
                        id,
                        price: formatPrice(Number(price)),
                        currency_code: currencyCode,
                        category: categoryPath,
                        brand
                    }
                ]
            }
        },
        is_sale_item,
        _clear: true
    }
}
